// import React from "react";
// import ReactDOM from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";

// import App from "./App.tsx";
// import { Provider } from "./provider.tsx";
// import "@/styles/globals.css";

// ReactDOM.createRoot(document.getElementById("root")!).render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <Provider>
//         <App />
//       </Provider>
//     </BrowserRouter>
//   </React.StrictMode>,
// );

import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { HeroUIProvider } from "@heroui/system";

import router from "./router";
import { ThemeProvider } from "./context/ThemeContext";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <HeroUIProvider>
        <RouterProvider router={router} />
      </HeroUIProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
